<div class="conteudo">

  <div *ngIf="proximoCliente && !roteiroFinalizado" class="card-proximo-cliete ">
    <div class="container-proximo-cliente">
      <span class="subtext-proximo-cliente">Próximo cliente</span>
      <div class="d-flex justify-content-between">
        <span class="titulo-proximo-cliente">
          {{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? proximoCliente.NomeFantasia : proximoCliente.RazaoSocial }}  - ({{ proximoCliente.CodigoCliente }})
        </span>
        <a  (click)="exibirClienteMapa(proximoCliente.CodigoCliente)" class="seleciona-cliente hide-on-mobile">
            <img placement="top" ngbTooltip="Ver no mapa" src="assets/img/icons/icon-abrir-map-green.svg" alt="Abrir mapa do cliente">
        </a>
      </div>
    </div>

  </div>
  <div class="input-container">
    <input class="input-busca" placeholder="Busca..." type="text" [(ngModel)]="pesquisaCliente">
  </div>

  <div *ngIf="exibirBotaoDownloadComprovantes" class="btn-download-comprovantes hide-on-mobile">
    <button
      (click)="toggleModalDownloadComprovantes()">
      <img src="assets/img/icons/download_comprovante_dark.svg" alt="">
      <span>Baixar todos os comprovantes</span>
    </button>
  </div>

  <div class="conteudo-checkbox">
    <label class="mb-0">
      <input
        type="checkbox"

        [(ngModel)]="mostrarClientesVisitados"
      />
      <span></span>
    </label>
    <span class="text-checkbox">Mostrar clientes visitados</span>
  </div>


  <ul class="clientes-selecionados">
      <li *ngFor="let item of listaRoteiroCliente | searchfilter:pesquisaCliente:false; let i = index">
        <div *ngIf="mostrarClientesVisitados || item.IdRoteiroPedidoSituacao == 1">
          <div *ngIf="item.RazaoSocial; else intervalo">
            <a class="roteiro-handler chama-roteiro"></a>

            <div class="item-cliente">
                <div>
                    <span class="cliente-icon"><img [src]="item.urlImagemRoteiroBoxLateral" (click)="exibirClienteMapa(item.CodigoCliente)"></span>
                    <div class="info-principal">
                        <p class="nome">
                            <span class="custom-control-description m-left razao-social">
                                {{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? item.NomeFantasia : item.RazaoSocial }}
                                <span class="razao-social-codigo"> {{ item.CodigoCliente }}</span>
                            </span>
                        </p>
                        <div class="data-pedido m-left" title='Data do Pedido'>
                            <span [class.alerta]="item.entregaAtrasada == 1" [class.atrasada]="item.entregaAtrasada == 2">
                                {{ item.DataPedido | date: 'dd/MM/yyyy' }}
                            </span>
                            <div class="d-flex">
                              <span style="text-decoration: underline;">{{ item.Bairro }}</span>
                              <img width="12px" src="assets/img/icons/icon-chevron-down.svg"
                                [ngClass]="{'rotated': i === selectedIndex}"
                                class="pull-right icon-menu icon ms-1"
                                alt=""
                                [class.selected]="item.show"
                                (click)="showHideAddress(i)">
                            </div>

                        </div>





                        <box-info-router-addess *ngIf="item.show" [item]=item></box-info-router-addess>

                        <div *ngIf="item.CodigoAcao != 5 && item.problemaReportado == 1" class="pill-oc-reportada">
                          <div class="pill-content">
                            <img src="assets/img/icons/exclamation-triangle-sem-fundo.svg" alt="">
                            <span class="pill-text">Entrega com ocorrência reportada</span>
                          </div>
                        </div>
                        <app-detalhe-entrega-coleta [item]="item" ></app-detalhe-entrega-coleta>

                      <div *ngIf="item.pedidos[0].NotaAvaliacao" class="d-flex mt-2 container-nota-avaliacao me-4">
                          <div>Avaliação da entrega
                            <i class="bi bi-info-circle" placement="top"
                                tooltipClass="custom-tooltip"
                                ngbTooltip="Avaliação de origem do painel de entregas."
                                tooltipClass="classTooltip">
                              </i>
                            :
                            </div>
                          <div class="star-rating">
                            <ng-container *ngFor="let star of stars; index as i">
                              <i [ngClass]="i < item.pedidos[0].NotaAvaliacao ? 'bi-star-fill' : 'bi-star'" class="bi"></i>
                            </ng-container>
                          </div>
                      </div>

                      <div class="d-flex align-items-end"
                        [ngClass]="{'justify-content-between': item.chaveAcesso && mostrarBtnCompartilharRast,  'justify-content-end': item.chaveAcesso == null || !mostrarBtnCompartilharRast}">
                        <div *ngIf="item.chaveAcesso && mostrarBtnCompartilharRast ">
                          <div (click)="copiarAcomponhamento(item.chaveAcesso)">
                              <app-texto-link
                                placement="bottom"
                                titulo="Copiar Link de Rastreio" icone='clipboard'
                              >
                              </app-texto-link>
                          </div>
                        </div>

                        <div *ngIf="mostraComprovanteApp && (item.pedidos[0].IdRoteiroPedidoSituacao == 6 || item.pedidos[0].IdRoteiroPedidoSituacao == 7)" >
                          <img *ngIf="item.DesabilitaVisualizacao" class="me-4" placement="top" ngbTooltip="Comprovante expirado: O Armazenamento online de comprovantes pelo Painel do Target Rota Plan tem duração de um ano." src="assets/img/icons/icon-exclamation-circle-orange.svg" alt="">

                          <div (click)="getComprovante(item)" *ngIf="!item.ColetaAssinaturaRecusada;else recusaColetaMotorista">
                         <app-texto-link
                            placement="bottom"
                            titulo="Ver dados recebedor"
                            icone='dados_recebedor'
                            [disabled]="item.DesabilitaVisualizacao"
                            (click)="abrirComprovanteModal()">
                          </app-texto-link>
                          </div>
                          <ng-template #recusaColetaMotorista>
                            <app-foto-assinatura-nao-coletada></app-foto-assinatura-nao-coletada>
                          </ng-template>
                        </div>
                      </div>



                        <div class="mt-3" *ngIf="item.imgLocalEntrega" title="Imagem do local da entrega">
                          <a class="btn-hover btn-local-entrega" data-bs-toggle="modal" data-bs-target="#modalLocalEntrega" (click)="abreImgLocalEntrega(item)"><i class="fa fa-eye me-2"></i>Foto do Check-in</a>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <ng-template #intervalo>
            <div class="item-cliente">
              <div>
                  <span class="cliente-icon"><img [src]="item.urlIcon"></span>
                  <div class="info-principal">
                      <p class="nome">
                          <span class="custom-control-description m-left">
                              {{ item.nome.toUpperCase() }}
                              <div class="intervalo">
                                 <img src="assets/img/delivery.svg" style="width: 17px;margin-bottom: 1px;">
                                 <span >  {{  (item.minutos === '0'? 'Entregas continuam no próximo dia' : 'Parada prev. ' +  item.minutos + 'min' )  }} </span>
                              </div>
                          </span>
                      </p>
                  </div>
              </div>
          </div>
          </ng-template>
        </div>

      </li>
  </ul>
</div>
<app-popup-download-todos-comprovantes *ngIf="boxInfoRouterService.exibirModalComprovante" [listaRoteiroClientes]="listaRoteiroCliente"></app-popup-download-todos-comprovantes>
